import axios from "axios";
import config from "../config";
import { getDoctorToken } from '../utils'

const getAppointmentDetailApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}book-appointment/${params.id}`,
    method: "get",
    params: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default getAppointmentDetailApi;
